<div class="panel mb-4">
  @if (!appSettings.isMobile()) {
    <div class="step-header d-flex align-items-center justify-content-between gap-3">
      <h5 class="mb-0 text-dark fw-bold text-nowrap">
        <i class="fas fa-hand-holding-heart me-2 text-primary"></i>Generar solicitud de beneficio
      </h5>
    </div>
  }

  <div class="step-body" [class.p-3]="appSettings.isMobile()">
    @if (partyInput()) {
      <app-party-form [partyForm]="partyForm" [mode]="formMode.VIEW"></app-party-form>
    }

    @if (benefitForm) {
      <form class="mt-3" [formGroup]="benefitForm">
        <div class="mb-3">
          <label class="form-label fw-bold small text-uppercase text-muted">Tipo de beneficio</label>
          <app-sheet-select
            [items]="benefitTypes"
            bindLabel="name"
            bindValue="id"
            title="Tipo de beneficio"
            placeholder="Seleccione el tipo de beneficio..."
            formControlName="type"
            [clearable]="false"
            [searchable]="benefitTypes.length > 5">
          </app-sheet-select>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold small text-uppercase text-muted">Vehículo del socio</label>
          <app-sheet-select
            [items]="vehicleSelectItems()"
            bindLabel="selectLabel"
            bindValue="uuid"
            title="Vehículo del socio"
            placeholder="Seleccione un vehículo..."
            formControlName="vehicleUuid"
            [clearable]="false"
            [searchable]="vehicleSelectItems().length > 5">
          </app-sheet-select>
        </div>

        @if (isTowTruck) {
          <div class="mb-3">
            <label class="form-label fw-bold small text-uppercase text-muted">Kilómetros (grúa)</label>
            <input type="number" class="form-control" formControlName="km" min="1" step="1" placeholder="Ej. 120">
          </div>
        }

        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label fw-bold small text-uppercase text-muted">Fecha</label>
            <input type="date" class="form-control" formControlName="date">
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold small text-uppercase text-muted">Monto solicitado</label>
            <input type="number" class="form-control" formControlName="amount" min="1" step="1" placeholder="0">
          </div>
        </div>

        @if (capPreview(); as cap) {
          <div class="mt-3">
            @if (cap.hasCap) {
              <div class="alert mb-0 py-2"
                [class.alert-success]="!cap.overCap"
                [class.alert-warning]="cap.overCap">
                Tope reglamentario
                <strong>{{ cap.capPercent }}% FMR</strong>
                = <strong>{{ cap.capAmount | currency:'CLP':'$':'1.0-0' }}</strong>
                @if (cap.overCap) {
                  <span class="d-block small mt-1">El monto supera el tope (se puede enviar con advertencia).</span>
                }
              </div>
            } @else if (selectedType()) {
              <div class="alert alert-secondary mb-0 py-2 small">
                Este tipo no tiene tope porcentual sobre FMR (reembolso contra boleta).
              </div>
            }
          </div>
        }
      </form>
    }
  </div>

  @if (!appSettings.isMobile()) {
    <div class="step-footer">
      <button type="button" class="btn btn-outline-danger btn-sm px-3" (click)="onClose.emit(true)" [disabled]="isSaving()">
        <i class="fas fa-times me-2"></i>Cancelar
      </button>
      <button type="button" class="btn btn-primary btn-sm px-4" (click)="submit()" [disabled]="isSaving()">
        @if (isSaving()) {
          <span class="spinner-border spinner-border-sm me-2"></span>Enviando...
        } @else {
          <i class="fas fa-paper-plane me-1"></i>Enviar solicitud
        }
      </button>
    </div>
  }
</div>

<app-mobile-footer [visible]="true">
  <button type="button" class="btn btn-primary btn-sm w-100" (click)="submit()" [disabled]="isSaving()">
    @if (isSaving()) {
      <span class="spinner-border spinner-border-sm me-1"></span>
    } @else {
      <i class="fas fa-paper-plane me-1"></i>
    }
    Enviar
  </button>
</app-mobile-footer>
